import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box, Typography } from '@saviynt/design-system';
import moment from 'moment';
import PropTypes from 'prop-types';

import { getMessageKey } from '../../../utils/utils';
import ARSAccordian from '../ARSAccordian';
import ARSTimeLineIconLarge from '../ARSTimeLineIconLarge';
import { DATE_FIELDS } from '../constant';

function ARSRequestTile({
  requestTileData,
  approverTileData,
  globalDateFormat,
}) {
  if (!requestTileData) return null;

  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const {
    arsRequestSectionLabelKey,
    // arsRequestSectionLabelValue,
    arsRequestMap,
    messageKeys,
  } = requestTileData;

  const requesterKeyMap = Object?.keys(arsRequestMap);
  const shouldRenderRequesterList = Boolean(requesterKeyMap?.length > 0);

  return (
    <ARSAccordian>
      <ARSTimeLineIconLarge tail={approverTileData ? 'fill' : 'none'} />
      <Box tag='div' className='AccessRequestHistoryBody-accordianBox'>
        <Typography
          kind='h3'
          className='AccessRequestHistoryBody-accordianBoxTitle'>
          {messages?.[arsRequestSectionLabelKey] ||
            localize(intl, getMessageKey(arsRequestSectionLabelKey))}
        </Typography>
        {shouldRenderRequesterList && (
          <Box tag='div' className='AccessRequestHistoryBody-accordianBoxBody'>
            {requesterKeyMap?.map((key) => {
              let fieldValue = arsRequestMap?.[key];

              if (DATE_FIELDS.includes(key)) {
                fieldValue = moment
                  .utc(fieldValue)
                  .local()
                  .format(`${globalDateFormat?.toUpperCase()} HH:mm:ss`);
              }

              return (
                <Box
                  key={key}
                  tag='div'
                  className='AccessRequestHistoryBody-accordianBoxBodyTile'>
                  <Typography kind='body3'>
                    {messageKeys?.[messageKeys?.[key]] ||
                      localize(intl, getMessageKey(messageKeys?.[key]))}
                  </Typography>
                  <Typography
                    kind='body2'
                    className='AccessRequestHistoryBody-accordianBoxBodyHighlighted'>
                    {fieldValue}
                  </Typography>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </ARSAccordian>
  );
}

ARSRequestTile.propTypes = {
  requestTileData: PropTypes.shape({
    arsRequestSectionLabelKey: PropTypes.string,
    arsRequestSectionLabelValue: PropTypes.string,
    arsRequestMap: PropTypes.shape({}),
    messageKeys: PropTypes.shape({}),
  }).isRequired,
  approverTileData: PropTypes.shape({}).isRequired,
  globalDateFormat: PropTypes.string.isRequired,
};

export default ARSRequestTile;
